import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { cloneDeep, uniq, get } from 'lodash';
import router from '@/router';
import setting from '@/setting.js';

// 判定是否需要缓存
var isKeepAlive = function isKeepAlive(data) {
  return get(data, 'meta.cache', false);
};
export default {
  namespaced: true,
  state: {
    // 可以在多页 tab 模式下显示的页面
    pool: [],
    // 当前显示的多页面列表
    opened: get(setting, 'page.opened', []),
    // 已经加载多标签页数据 https://github.com/d2-projects/d2-admin/issues/201
    openedLoaded: false,
    // 当前页面
    current: '',
    // 需要缓存的页面 name
    keepAlive: []
  },
  actions: {
    /**
     * @description 确认已经加载多标签页数据 https://github.com/d2-projects/d2-admin/issues/201
     * @param {Object} context
     */
    isLoaded: function isLoaded(_ref) {
      var state = _ref.state;
      if (state.openedLoaded) return Promise.resolve();
      return new Promise(function (resolve) {
        var timer = setInterval(function () {
          if (state.openedLoaded) resolve(clearInterval(timer));
        }, 10);
      });
    },
    /**
     * @class opened
     * @description 从持久化数据载入标签页列表
     * @param {Object} context
     */
    openedLoad: function openedLoad(_ref2) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var state, commit, dispatch, value, valid;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              state = _ref2.state, commit = _ref2.commit, dispatch = _ref2.dispatch;
              _context.n = 1;
              return dispatch('d2admin/db/get', {
                dbName: 'sys',
                path: 'page.opened',
                defaultValue: setting.page.opened,
                user: true
              }, {
                root: true
              });
            case 1:
              value = _context.v;
              // 在处理函数中进行数据优化 过滤掉现在已经失效的页签或者已经改变了信息的页签
              // 以 fullPath 字段为准
              // 如果页面过多的话可能需要优化算法
              // valid 有效列表 1, 1, 0, 1 => 有效, 有效, 失效, 有效
              valid = []; // 处理数据
              state.opened = value.map(function (opened) {
                // 忽略首页
                if (opened.fullPath === '/index') {
                  valid.push(1);
                  return opened;
                }
                // 尝试在所有的支持多标签页的页面里找到 name 匹配的页面
                var find = state.pool.find(function (item) {
                  return item.name === opened.name;
                });
                // 记录有效或无效信息
                valid.push(find ? 1 : 0);
                // 返回合并后的数据 新的覆盖旧的
                // 新的数据中一般不会携带 params 和 query, 所以旧的参数会留存
                return Object.assign({}, opened, find);
              }).filter(function (opened, index) {
                return valid[index] === 1;
              });
              // 标记已经加载多标签页数据 https://github.com/d2-projects/d2-admin/issues/201
              state.openedLoaded = true;
              // 根据 opened 数据生成缓存设置
              commit('keepAliveRefresh');
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    /**
     * 将 opened 属性赋值并持久化 在这之前请先确保已经更新了 state.opened
     * @param {Object} context
     */
    opened2db: function opened2db(_ref3) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var state, dispatch;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              state = _ref3.state, dispatch = _ref3.dispatch;
              // 设置数据
              dispatch('d2admin/db/set', {
                dbName: 'sys',
                path: 'page.opened',
                value: state.opened,
                user: true
              }, {
                root: true
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    /**
     * @class opened
     * @description 更新页面列表上的某一项
     * @param {Object} context
     * @param {Object} payload { index, params, query, fullPath } 路由信息
     */
    openedUpdate: function openedUpdate(_ref4, _ref5) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var state, commit, dispatch, index, params, query, fullPath, page;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              state = _ref4.state, commit = _ref4.commit, dispatch = _ref4.dispatch;
              index = _ref5.index, params = _ref5.params, query = _ref5.query, fullPath = _ref5.fullPath;
              // 更新页面列表某一项
              page = state.opened[index];
              page.params = params || page.params;
              page.query = query || page.query;
              page.fullPath = fullPath || page.fullPath;
              state.opened.splice(index, 1, page);
              // 持久化
              _context3.n = 1;
              return dispatch('opened2db');
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    /**
     * @class opened
     * @description 重排页面列表上的某一项
     * @param {Object} context
     * @param {Object} payload { oldIndex, newIndex } 位置信息
     */
    openedSort: function openedSort(_ref6, _ref7) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var state, commit, dispatch, oldIndex, newIndex, page;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              state = _ref6.state, commit = _ref6.commit, dispatch = _ref6.dispatch;
              oldIndex = _ref7.oldIndex, newIndex = _ref7.newIndex;
              // 重排页面列表某一项
              page = state.opened[oldIndex];
              state.opened.splice(oldIndex, 1);
              state.opened.splice(newIndex, 0, page);
              // 持久化
              _context4.n = 1;
              return dispatch('opened2db');
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    /**
     * @class opened
     * @description 新增一个 tag (打开一个页面)
     * @param {Object} context
     * @param {Object} payload new tag info
     */
    add: function add(_ref8, _ref9) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var state, commit, dispatch, tag, params, query, fullPath, newTag;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              state = _ref8.state, commit = _ref8.commit, dispatch = _ref8.dispatch;
              tag = _ref9.tag, params = _ref9.params, query = _ref9.query, fullPath = _ref9.fullPath;
              // 设置新的 tag 在新打开一个以前没打开过的页面时使用
              newTag = tag;
              newTag.params = params || newTag.params;
              newTag.query = query || newTag.query;
              newTag.fullPath = fullPath || newTag.fullPath;
              // 添加进当前显示的页面数组
              state.opened.push(newTag);
              // 如果这个页面需要缓存 将其添加到缓存设置
              if (isKeepAlive(newTag)) commit('keepAlivePush', tag.name);
              // 持久化
              _context5.n = 1;
              return dispatch('opened2db');
            case 1:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    /**
     * @class current
     * @description 打开一个新的页面
     * @param {Object} context
     * @param {Object} payload 从路由钩子的 to 对象上获取 { name, params, query, fullPath, meta } 路由信息
     */
    open: function open(_ref0, _ref1) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var state, commit, dispatch, name, params, query, fullPath, meta, opened, pageOpendIndex, pageOpend, page;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              state = _ref0.state, commit = _ref0.commit, dispatch = _ref0.dispatch;
              name = _ref1.name, params = _ref1.params, query = _ref1.query, fullPath = _ref1.fullPath, meta = _ref1.meta;
              // 已经打开的页面
              opened = state.opened; // 判断此页面是否已经打开 并且记录位置
              pageOpendIndex = 0;
              pageOpend = opened.find(function (page, index) {
                var same = page.fullPath === fullPath;
                pageOpendIndex = same ? index : pageOpendIndex;
                return same;
              });
              if (!pageOpend) {
                _context6.n = 2;
                break;
              }
              _context6.n = 1;
              return dispatch('openedUpdate', {
                index: pageOpendIndex,
                params: params,
                query: query,
                fullPath: fullPath
              });
            case 1:
              _context6.n = 3;
              break;
            case 2:
              // 页面以前没有打开过
              page = state.pool.find(function (t) {
                return t.name === name;
              }); // 如果这里没有找到 page 代表这个路由虽然在框架内 但是不参与标签页显示
              if (!page) {
                _context6.n = 3;
                break;
              }
              _context6.n = 3;
              return dispatch('add', {
                tag: Object.assign({}, page),
                params: params,
                query: query,
                fullPath: fullPath
              });
            case 3:
              // 如果这个页面需要缓存 将其添加到缓存设置
              if (isKeepAlive({
                meta: meta
              })) commit('keepAlivePush', name);
              // 设置当前的页面
              commit('currentSet', fullPath);
            case 4:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    /**
     * @class opened
     * @description 关闭一个 tag (关闭一个页面)
     * @param {Object} context
     * @param {Object} payload { tagName: 要关闭的标签名字 }
     */
    close: function close(_ref10, _ref11) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var state, commit, dispatch, tagName, newPage, isCurrent, len, i, index, _newPage, _newPage$name, name, _newPage$params, params, _newPage$query, query, routerObj;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              state = _ref10.state, commit = _ref10.commit, dispatch = _ref10.dispatch;
              tagName = _ref11.tagName;
              // 预定下个新页面
              newPage = {};
              isCurrent = state.current === tagName; // 如果关闭的页面就是当前显示的页面
              if (!isCurrent) {
                _context7.n = 3;
                break;
              }
              // 去找一个新的页面
              len = state.opened.length;
              i = 0;
            case 1:
              if (!(i < len)) {
                _context7.n = 3;
                break;
              }
              if (!(state.opened[i].fullPath === tagName)) {
                _context7.n = 2;
                break;
              }
              newPage = i < len - 1 ? state.opened[i + 1] : state.opened[i - 1];
              return _context7.a(3, 3);
            case 2:
              i++;
              _context7.n = 1;
              break;
            case 3:
              // 找到这个页面在已经打开的数据里是第几个
              index = state.opened.findIndex(function (page) {
                return page.fullPath === tagName;
              });
              if (index >= 0) {
                // 如果这个页面是缓存的页面 将其在缓存设置中删除
                commit('keepAliveRemove', state.opened[index].name);
                // 更新数据 删除关闭的页面
                state.opened.splice(index, 1);
              }
              // 持久化
              _context7.n = 4;
              return dispatch('opened2db');
            case 4:
              if (!isCurrent) {
                _context7.n = 5;
                break;
              }
              _newPage = newPage, _newPage$name = _newPage.name, name = _newPage$name === void 0 ? 'index' : _newPage$name, _newPage$params = _newPage.params, params = _newPage$params === void 0 ? {} : _newPage$params, _newPage$query = _newPage.query, query = _newPage$query === void 0 ? {} : _newPage$query;
              routerObj = {
                name: name,
                params: params,
                query: query
              };
              _context7.n = 5;
              return router.push(routerObj);
            case 5:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    /**
     * @class opened
     * @description 关闭当前标签左边的标签
     * @param {Object} context
     * @param {Object} payload { pageSelect: 当前选中的tagName }
     */
    closeLeft: function closeLeft(_ref12) {
      var _arguments = arguments;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var state, commit, dispatch, _ref13, pageSelect, pageAim, currentIndex, i;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              state = _ref12.state, commit = _ref12.commit, dispatch = _ref12.dispatch;
              _ref13 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, pageSelect = _ref13.pageSelect;
              pageAim = pageSelect || state.current;
              currentIndex = 0;
              state.opened.forEach(function (page, index) {
                if (page.fullPath === pageAim) currentIndex = index;
              });
              if (!(currentIndex > 0)) {
                _context8.n = 4;
                break;
              }
              i = state.opened.length - 1;
            case 1:
              if (!(i >= 0)) {
                _context8.n = 4;
                break;
              }
              if (!(state.opened[i].name === 'index' || i >= currentIndex)) {
                _context8.n = 2;
                break;
              }
              return _context8.a(3, 3);
            case 2:
              commit('keepAliveRemove', state.opened[i].name);
              state.opened.splice(i, 1);
            case 3:
              i--;
              _context8.n = 1;
              break;
            case 4:
              _context8.n = 5;
              return dispatch('opened2db');
            case 5:
              // 设置当前的页面
              state.current = pageAim;
              if (!(router.app.$route.fullPath !== pageAim)) {
                _context8.n = 6;
                break;
              }
              _context8.n = 6;
              return router.push(pageAim);
            case 6:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    /**
     * @class opened
     * @description 关闭当前标签右边的标签
     * @param {Object} context
     * @param {Object} payload { pageSelect: 当前选中的tagName }
     */
    closeRight: function closeRight(_ref14) {
      var _arguments2 = arguments;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var state, commit, dispatch, _ref15, pageSelect, pageAim, currentIndex, i;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              state = _ref14.state, commit = _ref14.commit, dispatch = _ref14.dispatch;
              _ref15 = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {}, pageSelect = _ref15.pageSelect;
              pageAim = pageSelect || state.current;
              currentIndex = 0;
              state.opened.forEach(function (page, index) {
                if (page.fullPath === pageAim) currentIndex = index;
              });
              // 删除打开的页面 并在缓存设置中删除
              i = state.opened.length - 1;
            case 1:
              if (!(i >= 0)) {
                _context9.n = 4;
                break;
              }
              if (!(state.opened[i].name === 'index' || currentIndex >= i)) {
                _context9.n = 2;
                break;
              }
              return _context9.a(3, 3);
            case 2:
              commit('keepAliveRemove', state.opened[i].name);
              state.opened.splice(i, 1);
            case 3:
              i--;
              _context9.n = 1;
              break;
            case 4:
              _context9.n = 5;
              return dispatch('opened2db');
            case 5:
              // 设置当前的页面
              state.current = pageAim;
              if (!(router.app.$route.fullPath !== pageAim)) {
                _context9.n = 6;
                break;
              }
              _context9.n = 6;
              return router.push(pageAim);
            case 6:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    /**
     * @class opened
     * @description 关闭当前激活之外的 tag
     * @param {Object} context
     * @param {Object} payload { pageSelect: 当前选中的tagName }
     */
    closeOther: function closeOther(_ref16) {
      var _arguments3 = arguments;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var state, commit, dispatch, _ref17, pageSelect, pageAim, currentIndex, i;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              state = _ref16.state, commit = _ref16.commit, dispatch = _ref16.dispatch;
              _ref17 = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : {}, pageSelect = _ref17.pageSelect;
              pageAim = pageSelect || state.current;
              currentIndex = 0;
              state.opened.forEach(function (page, index) {
                if (page.fullPath === pageAim) currentIndex = index;
              });
              // 删除打开的页面数据 并更新缓存设置
              i = state.opened.length - 1;
            case 1:
              if (!(i >= 0)) {
                _context0.n = 4;
                break;
              }
              if (!(state.opened[i].name === 'index' || currentIndex === i)) {
                _context0.n = 2;
                break;
              }
              return _context0.a(3, 3);
            case 2:
              commit('keepAliveRemove', state.opened[i].name);
              state.opened.splice(i, 1);
            case 3:
              i--;
              _context0.n = 1;
              break;
            case 4:
              _context0.n = 5;
              return dispatch('opened2db');
            case 5:
              // 设置新的页面
              state.current = pageAim;
              if (!(router.app.$route.fullPath !== pageAim)) {
                _context0.n = 6;
                break;
              }
              _context0.n = 6;
              return router.push(pageAim);
            case 6:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    /**
     * @class opened
     * @description 关闭所有 tag
     * @param {Object} context
     */
    closeAll: function closeAll(_ref18) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var state, commit, dispatch, i;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              state = _ref18.state, commit = _ref18.commit, dispatch = _ref18.dispatch;
              i = state.opened.length - 1;
            case 1:
              if (!(i >= 0)) {
                _context1.n = 4;
                break;
              }
              if (!(state.opened[i].name === 'index')) {
                _context1.n = 2;
                break;
              }
              return _context1.a(3, 3);
            case 2:
              commit('keepAliveRemove', state.opened[i].name);
              state.opened.splice(i, 1);
            case 3:
              i--;
              _context1.n = 1;
              break;
            case 4:
              _context1.n = 5;
              return dispatch('opened2db');
            case 5:
              if (!(router.app.$route.name !== 'index')) {
                _context1.n = 6;
                break;
              }
              _context1.n = 6;
              return router.push({
                name: 'index'
              });
            case 6:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    }
  },
  mutations: {
    /**
     * @class keepAlive
     * @description 从已经打开的页面记录中更新需要缓存的页面记录
     * @param {Object} state state
     */
    keepAliveRefresh: function keepAliveRefresh(state) {
      state.keepAlive = state.opened.filter(function (item) {
        return isKeepAlive(item);
      }).map(function (e) {
        return e.name;
      });
    },
    /**
     * @description 删除一个页面的缓存设置
     * @param {Object} state state
     * @param {String} name name
     */
    keepAliveRemove: function keepAliveRemove(state, name) {
      var list = cloneDeep(state.keepAlive);
      var index = list.findIndex(function (item) {
        return item === name;
      });
      if (index !== -1) {
        list.splice(index, 1);
        state.keepAlive = list;
      }
    },
    /**
     * @description 增加一个页面的缓存设置
     * @param {Object} state state
     * @param {String} name name
     */
    keepAlivePush: function keepAlivePush(state, name) {
      var keep = cloneDeep(state.keepAlive);
      keep.push(name);
      state.keepAlive = uniq(keep);
    },
    /**
     * @description 清空页面缓存设置
     * @param {Object} state state
     */
    keepAliveClean: function keepAliveClean(state) {
      state.keepAlive = [];
    },
    /**
     * @class current
     * @description 设置当前激活的页面 fullPath
     * @param {Object} state state
     * @param {String} fullPath new fullPath
     */
    currentSet: function currentSet(state, fullPath) {
      state.current = fullPath;
    },
    /**
     * @class pool
     * @description 保存 pool (候选池)
     * @param {Object} state state
     * @param {Array} routes routes
     */
    init: function init(state, routes) {
      var pool = [];
      var _push = function push(routes) {
        routes.forEach(function (route) {
          if (route.children && route.children.length > 0) {
            _push(route.children);
          } else {
            if (!route.hidden) {
              var meta = route.meta,
                name = route.name,
                path = route.path;
              pool.push({
                meta: meta,
                name: name,
                path: path
              });
            }
          }
        });
      };
      _push(routes);
      state.pool = pool;
    }
  }
};